<p-dialog header="Edit Order" [modal]="true" [(visible)]="editVisible"
    [style]="{ width: '50rem', borderRadius: '16px' }">
    <div class="p-1">
        <!-- Order Info Section -->
        <div class="mb-5">
            <h5 class="text-lg text-700 mb-4">Order Details</h5>
            
            <!-- Checkbox for External Trailer -->
            <div class="flex align-items-center gap-2 mb-2">
                <p-checkbox 
                    [(ngModel)]="isExternalTrailer" 
                    [binary]="true"
                    (onChange)="onTrailerTypeChange()"
                    inputId="external-trailer">
                </p-checkbox>
                <label for="external-trailer" class="text-sm text-500">Use another trailer</label>
            </div>

            <!-- All Inputs in One Row -->
            <div class="flex justify-content-center gap-3">
                <!-- Trailer Input Section -->
                <div class="flex-1">
                    <label for="trailer" class="block text-sm font-medium mb-2">Trailer</label>
                    <div [ngSwitch]="isExternalTrailer">
                        <p-dropdown *ngSwitchCase="false"
                            id="trailer"
                            [options]="trailers"
                            [(ngModel)]="editingOrder.trailer_id"
                            [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem'}"
                            styleClass="w-full p-2"
                            optionLabel="label"
                            optionValue="value"
                            appendTo="body"
                            [filter]="true"
                            [filterBy]="'label'"
                            [filterPlaceholder]="'Search trailers'"
                            [filterMatchMode]="'contains'"
                            [filterFields]="['label']">
                        </p-dropdown>
                        <input *ngSwitchCase="true"
                            pInputText 
                            [(ngModel)]="editingOrder.external_trailer_number" 
                            [style]="{'width':'100%', 'padding':'1rem', 'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem'}"
                             />
                    </div>
                </div>

                <!-- Pickup Number -->
                <div class="flex-1">
                    <label for="pickup_number" class="block text-sm font-medium mb-2">Pick Up Number</label>
                    <input pInputText 
                        id="pickup_number"
                        [(ngModel)]="editingOrder.pickup_number" 
                        placeholder="Enter pickup number"
                        [style]="{'width':'100%', 'padding':'1rem', 'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem'}"
                         />
                </div>

                <!-- Load Type -->
                <div class="flex-1">
                    <label for="load_type" class="block text-sm font-medium mb-2">Load Type</label>
                    <p-dropdown 
                        id="load_type"
                        [options]="loadType" 
                        placeholder="Select Type" 
                        [(ngModel)]="editingOrder.load_type"
                        optionLabel="label" 
                        optionValue="value"
                        [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem'}"
                        styleClass="w-full p-2" appendTo="body">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <!-- Company Info Section -->
        <div class="mb-5">
            <h5 class="text-lg text-700 mb-4">Company Information</h5>
            <div class="flex flex-column gap-4 mb-4">
                <div class="w-full">
                    <label for="supplier_id" class="block text-sm font-medium mb-2">Shipper</label>
                    <p-dropdown 
                        id="supplier_id"
                        [options]="supplierOptions"
                        [(ngModel)]="editingOrder.supplier_selection"
                        optionLabel="name"
                        optionValue="value"
                        [filter]="true"
                        [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem', 'width': '100%'}"
                        styleClass="w-full p-2"
                        placeholder="Select a shipper"
                        (onChange)="onEditSupplierChange($event.value)"
                        appendTo="body">
                    </p-dropdown>
                </div>

                <div class="w-full">
                    <label for="receiver_id" class="block text-sm font-medium mb-2">Receiver</label>
                    <p-dropdown 
                        id="receiver_id"
                        [options]="getReceiversForSupplier(editingOrder.supplier_id)"
                        [(ngModel)]="editingOrder.receiver_selection"
                        optionLabel="name"
                        optionValue="value"
                        [filter]="true"
                        [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem', 'width': '100%'}"
                        styleClass="w-full p-2"
                        placeholder="Select a receiver"
                        (onChange)="onEditReceiverChange($event.value)"
                        appendTo="body">
                    </p-dropdown>
                </div>
            </div>
            <!-- Date Selection Row -->
            <div class="flex gap-4">
                <!-- Pickup Date -->
                <div class="flex-1">
                    <label class="block text-sm font-medium mb-2">Pick Up Date</label>
                    <div class="w-full">
                        <p-calendar 
                            [(ngModel)]="editingOrder.pickup_date"
                            [showTime]="showPickupTimePicker"
                            dateFormat="mm/dd/yy"
                            hourFormat="12"
                            [placeholder]="editingOrder.pickup_date ? toCentralTime(editingOrder.pickup_date) : 'Select Pick Up Date'"
                            [style]="{ 'width': '100%', 'border-radius': '12px', 'font-size': '1rem'}"
                            styleClass="w-full"
                            appendTo="body"
                            >
                        </p-calendar>
                        <div class="flex align-items-center gap-2 mt-2">
                            <p-checkbox 
                                [(ngModel)]="showPickupTimePicker" 
                                [binary]="true"
                                inputId="pickup-time-toggle">
                            </p-checkbox>
                            <label for="pickup-time-toggle" class="text-sm">Include time</label>
                        </div>
                    </div>
                </div>

                <!-- Delivery Date -->
                <div class="flex-1">
                    <label class="block text-sm font-medium mb-2">Delivery Date</label>
                    <div class="w-full">
                        <p-calendar 
                            [(ngModel)]="editingOrder.delivery_date"
                            [showTime]="showDeliveryTimePicker"
                            dateFormat="mm/dd/yy"
                            hourFormat="12"
                            [placeholder]="editingOrder.delivery_date ? toCentralTime(editingOrder.delivery_date) : 'Select Delivery Date'"
                            [style]="{ 'width': '100%', 'border-radius': '12px', 'font-size': '1rem'}"
                            styleClass="w-full"
                            appendTo="body"
                            >
                        </p-calendar>
                        <div class="flex align-items-center gap-2 mt-2">
                            <p-checkbox 
                                [(ngModel)]="showDeliveryTimePicker" 
                                [binary]="true"
                                inputId="delivery-time-toggle"
                                >
                            </p-checkbox>
                            <label for="delivery-time-toggle" class="text-sm">Include time</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Notes Section -->
        <div>
            <h5 class="text-lg text-700 mb-3">Additional Notes</h5>
            <textarea pInputTextarea [(ngModel)]="editingOrder.notes" placeholder="Notes (optional)" [rows]="3"
                class="w-full p-3" [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)'}">
        </textarea>
        </div>
    </div>


    <div class="flex justify-content-between px-5 pb-4 border-top-1 surface-border pt-4 dialog-footer">
        <!-- Left side -->
        <div>
            <p-button label="Delete Order" 
                    [raised]="true"
                      severity="danger" 
                      (onClick)="deleteOrder($event, editingOrder)" 
                      [outlined]="true"
                      [style]="{'border-radius': '12px'}" />
        </div>
        
        <!-- Right side -->
        <div class="flex gap-3">
            <p-button label="Cancel" 
                      severity="secondary" 
                      (onClick)="clearInput()" 
                      [text]="true"
                      [style]="{'border-radius': '12px'}" />
            <p-button label="Save Edit" 
                      (onClick)="saveEdit()" 
                      [raised]="true"
                      [outlined]="true"
                      [disabled]="!editingOrder.supplier_id || !editingOrder.receiver_id" 
                      severity="primary"
                      [style]="{'border-radius': '12px'}" />
        </div>
    </div>
    </p-dialog>
